// Demo IDs for planboard tour - use 999999xxx range
export const DEMO_MACHINE_ID = 999999999;

export const DEMO_OPERATION_IDS = {
  NO_MACHINE_1: 999999001,
  NO_MACHINE_2: 999999002,
  DEMO_MACHINE_1: 999999003,
  DEMO_MACHINE_2: 999999004,
} as const;

// Legacy demo machine ID (for cleaning up old persisted data)
export const LEGACY_DEMO_MACHINE_ID = -999;

// Threshold for identifying demo data
export const DEMO_ID_THRESHOLD = 999999000;
